// extracted by mini-css-extract-plugin
export default {"create-event-form":"CreateEvent_create-event-form__mEXbr","form-type":"CreateEvent_form-type__qEZPZ","Errors":"CreateEvent_Errors__w3TSx"};